import type { EnvSyncResult, VercelRunner } from '@cli-types/next-adapter/vercel.js'
import { ENV_ADD_TIMEOUT_MS } from '@cli-constants/timeouts.js'
import { parseDotenvFile } from '@cli-utils/files.js'
import { pullVercelEnvValue } from '../env-pull.js'
import { runVercel } from '../runner/run-vercel.js'
import { collectDeployEnvVars } from './collect-deploy-env-vars.js'

export async function syncVercelProductionEnv(
  runner: VercelRunner,
  cwd: string,
  env?: NodeJS.ProcessEnv
): Promise<EnvSyncResult> {
  const existingKeys =
    (await pullVercelEnvValue(
      runner,
      cwd,
      (filePath) => new Set(parseDotenvFile(filePath).keys()),
      env,
      'production'
    )) ?? new Set<string>()

  const synced: string[] = []
  const failed: string[] = []

  for (const { key, value } of collectDeployEnvVars(cwd, existingKeys)) {
    const add = await runVercel(runner, ['env', 'add', key, 'production'], {
      cwd,
      mode: 'capture',
      timeoutMs: ENV_ADD_TIMEOUT_MS,
      env,
      stdinInput: `${value}\n`
    })

    if (add.success) synced.push(key)
    else failed.push(key)
  }

  return { synced, failed }
}
